import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbItems = () => {
    const path = location?.pathname;
    const items = [];

    switch (path) {
      case '/dashboard':
        items?.push({ label: 'Dashboard', path: '/dashboard', isActive: true });
        break;
      
      case '/product-catalog':
        items?.push(
          { label: 'Products', path: '/product-catalog', isActive: false },
          { label: 'Product Catalog', path: '/product-catalog', isActive: true }
        );
        break;
      
      case '/product-details':
        items?.push(
          { label: 'Products', path: '/product-catalog', isActive: false },
          { label: 'Product Catalog', path: '/product-catalog', isActive: false },
          { label: 'Product Details', path: '/product-details', isActive: true }
        );
        break;
      
      case '/reports':
        items?.push({ label: 'Reports', path: '/reports', isActive: true });
        break;
      
      default:
        return [];
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  if (breadcrumbItems?.length === 0) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <Icon name="Home" size={16} className="text-muted-foreground" />
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={`${item?.path}-${item?.label}-${index}`}>
          <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          
          {item?.isActive ? (
            <span className="text-foreground font-medium" aria-current="page">
              {item?.label}
            </span>
          ) : (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleNavigation(item?.path)}
              className="h-auto p-0 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {item?.label}
            </Button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;